const PremiumFeature = Object.freeze({
  NEWS: 'NEWS'
})
export default PremiumFeature
// RESERVE BELOW
